import { each } from 'lodash';
import Swiper from 'swiper/bundle';
import { media, media_expression } from '../../utils/media';
import { app } from '../../utils/store';
export default class CarouselVersions {
    constructor(element) {
        this.element = element;

        this.carousel = {
            init: false,
            object: undefined,
            // element: document.querySelectorAll('.carousel[data-carousel="versions"]'),
            element: this.element,
        }

        this.createCarousel(this.carousel.element); // Init Carousel
        window.addEventListener('resize', this.onResize);
    }

    createCarousel(target) {
        if(app.page == 'line'){
            if(media('<Laptop')) {
                if (!this.carousel.init) {
                    this.carousel.init = true;
    
                    this.carousel.object = new Swiper(target, {
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        grabCursor: true,
                        scrollbar: {
                            el: ".swiper-scrollbar",
                            draggable: true,
                        },
                    });
                    
                    target.classList.remove('grid-list')

                    if(!!target && target.querySelectorAll('.swiper-slide').length > 3){
                        target.setAttribute('data-draggable',true)
                    }
                }
            } else if(media('>=Laptop')) {
                target.classList.add('grid-list')
                if(target.hasAttribute('data-draggable')){
                    target.removeAttribute('data-draggable')
                }

                this.carousel.init = false;
                
                if(this.carousel.object) { 
                    this.carousel.object.destroy()
                }
            }
        } else {
            this.carousel.init = true;

            this.carousel.object = new Swiper(target, {
                slidesPerView: 'auto',
                spaceBetween: 0,
                grabCursor: true,
                scrollbar: {
                    el: ".swiper-scrollbar",
                    draggable: true,
                },
            });
            
            if(!!target && target.querySelectorAll('.swiper-slide').length > 3){
                target.setAttribute('data-draggable',true)
            }
        }
    }

    onResize = () => {
        this.createCarousel(this.carousel.element);
    }
}